import { ThemeEvents, CartUpdateEvent } from '@theme/events';

if (!window.customElements.get('shipping-protection')) {
  class ShippingProtection extends HTMLElement {
    constructor() {
      super();
      console.log('constructor')
    }

    connectedCallback() {
      console.log('connected callback')

      // Default to enabled if no session value
      if (sessionStorage.getItem('noprotection') === null || sessionStorage.getItem('noprotection') == 'false') {
        sessionStorage.setItem('noprotection', 'false');

        const link = this.querySelector('[data-protection-id]');
        if (link) {
          link.classList.add('active');
        }

        // Kick off logic to add protection if needed
        this.handleProtectionLogic();
      }

      this.addEventListeners();
    }

    get variants() {
      try {
        return JSON.parse(this.dataset.variants || '[]');
      } catch {
        return [];
      }
    }

    get cartTotal() {
      return parseInt(this.dataset.cartTotal || '0', 10);
    }

    get currentProtectionId() {
      return this.dataset.currentId;
    }

    get cartItemCount() {
      return parseInt(this.dataset.cartItemCount || '0', 10);
    }

    get bestVariant() {
      return this.variants.find(
        (variant) => parseInt(variant.sku || '0', 10) > this.cartTotal
      );
    }

    handleProtectionLogic() {
      if (sessionStorage.getItem('noprotection') === 'true') return;
      console.log('lets add protection')

      const best = this.bestVariant;
      if (!best) return;

      const current = this.currentProtectionId;

      if (this.cartItemCount) return;

      if (current && current !== String(best.id)) {
        this.updateCart({ [current]: 0, [best.id]: 1 });
      } else if (this.cartItemCount === 1 && current) {
        this.updateCart({ [current]: 0 });
      } else if (this.cartItemCount > 0 && !current) {
        this.updateCart({ [best.id]: 1 });
      }
    }

    updateCart(updates) {
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el instanceof HTMLElement ? el.dataset.sectionId : null)
        .filter(Boolean);

      const payload = {
        updates, // { variantId: qty, ... }
        sections: sectionIds,
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((data) => {
          const event = new CartUpdateEvent({ data });
          document.dispatchEvent(event);
        })
        .catch((err) => console.error('Cart update error:', err));
    }

    addEventListeners() {
      const link = this.querySelector('[data-protection-id]');
      if (!link) return;

      link.addEventListener('click', (e) => {
        e.preventDefault();

        const variantId = link.dataset.protectionId;
        const currentVariantId = this.currentProtectionId;
        if (!variantId) return;

        const isActive = link.classList.contains('active');
        const disabling = isActive;

        // Toggle `noprotection`
        sessionStorage.setItem('noprotection', disabling ? 'true' : 'false');

        // Toggle class
        link.classList.toggle('active', !disabling);

        // Add or remove the protection product
        if (disabling) {
          this.updateCart({ [currentVariantId]: 0 });
        } else {
          this.updateCart({ [variantId]: 1 });
        }

        // Rerun logic (should early return if `noprotection` now true)
        this.handleProtectionLogic();
      });
    }
  }

  customElements.define('shipping-protection', ShippingProtection);
}